import script from "./ApolloEndpointsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApolloEndpointsView.vue?vue&type=script&setup=true&lang=js"

import "./ApolloEndpointsView.vue?vue&type=style&index=0&id=23fa23c2&lang=scss"

const __exports__ = script;

export default __exports__